import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ToiletIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ToiletIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.98065 2.90887C5.27654 2.90887 3.89014 4.2953 3.89014 5.99938C3.89014 7.70346 5.27653 9.08985 6.98065 9.08985C8.68477 9.08985 10.0712 7.70346 10.0712 5.99938C10.0712 4.2953 8.68477 2.90887 6.98065 2.90887ZM6.98065 7.89901C5.93311 7.89901 5.08094 7.0468 5.08094 5.99934C5.08094 4.95188 5.93315 4.09963 6.98065 4.09963C8.02815 4.09963 8.88036 4.95188 8.88036 5.99934C8.88036 7.0468 8.02819 7.89901 6.98065 7.89901Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.4626 10.8029C11.3519 10.639 11.167 10.5407 10.9691 10.5407H2.99239C2.79457 10.5407 2.60964 10.6389 2.49892 10.8029C2.3882 10.9669 2.36617 11.1751 2.44015 11.3586L6.42852 21.258C6.51931 21.4833 6.73784 21.6309 6.98076 21.6309C7.22368 21.6309 7.44224 21.4833 7.533 21.258L11.5214 11.3586C11.5953 11.1751 11.5733 10.9669 11.4626 10.8029ZM6.98077 19.4423L3.87415 11.7315H10.0874L6.98077 19.4423Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7389 2.90887C16.0348 2.90887 14.6484 4.2953 14.6484 5.99938C14.6484 7.70346 16.0348 9.08985 17.7389 9.08985C19.443 9.08985 20.8294 7.70346 20.8294 5.99938C20.8294 4.29527 19.443 2.90887 17.7389 2.90887ZM17.7389 7.89901C16.6914 7.89901 15.8392 7.0468 15.8392 5.99934C15.8392 4.95188 16.6914 4.09963 17.7389 4.09963C18.7864 4.09963 19.6386 4.95188 19.6386 5.99934C19.6386 7.0468 18.7864 7.89901 17.7389 7.89901Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.2796 20.813L18.2913 10.9136C18.2005 10.6883 17.982 10.5407 17.739 10.5407C17.4961 10.5407 17.2776 10.6883 17.1868 10.9136L13.1984 20.813C13.1245 20.9965 13.1465 21.2048 13.2572 21.3687C13.3679 21.5326 13.5528 21.6309 13.7507 21.6309H21.7274C21.9252 21.6309 22.1102 21.5326 22.2209 21.3687C22.3316 21.2047 22.3536 20.9964 22.2796 20.813ZM14.6324 20.4401L17.7391 12.7293L20.8457 20.4401H14.6324Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ToiletIcon;
